import { CommonModule } from '@angular/common';
import { Component, Input, NgModule } from '@angular/core';
import {
  DxTextAreaModule,
  DxTextBoxModule,
  DxButtonModule,
  DxToolbarModule,
  DxFileUploaderModule,
  DxValidationGroupModule,
  DxValidatorModule,
} from 'devextreme-angular';
import { UserAvatarComponent } from '../user-avatar/user-avatar.component';

@Component({
  selector: 'dk-card-messages',
  templateUrl: './card-messages.component.html',
  styleUrls: ['./card-messages.component.scss'],
  standalone: true,
  imports: [
    DxTextAreaModule,
    DxTextBoxModule,
    DxToolbarModule,
    DxFileUploaderModule,
    DxButtonModule,
    DxValidationGroupModule,
    DxValidatorModule,
    UserAvatarComponent,
    CommonModule,
  ],
})
export class CardMessagesComponent {
  @Input() user: string;

  @Input() items: any;

  messageTitle = '';

  messageText = '';

  getAvatarText(name: string) {
    return name
      .split(' ')
      .map((name) => name[0])
      .join('');
  }

  getText(data: any) {
    return data.text.replace(
      '{username}',
      data.manager !== this.items[0].manager
        ? this.items[0].manager
        : this.items[1].manager
    );
  }

  send = (e: any) => {
    if (!e.validationGroup.validate().isValid) {
      return;
    }

    const newMessage: any = {
      subject: this.messageTitle,
      text: this.messageText,
      manager: this.user,
      date: new Date(),
    };

    this.items.push(newMessage);

    e.validationGroup.reset();
  };
}
